/**
* Components are lazy-loaded - See "Grouping Components in the Same Chunk"
* http://router.vuejs.org/en/advanced/lazy-loading.html
*/
/* eslint-disable global-require */
const Auth = {
    login        : r => require.ensure([], () => r(require('./components/login')),         'auth'),
    register     : r => require.ensure([], () => r(require('./components/register')),      'auth'),
    verification : r => require.ensure([], () => r(require('./components/verification')),  'auth'),
    'learning'        : r => require.ensure([], () => r(require('./components/learning_login')),   'auth'),
    'learningdashboard'        : r => require.ensure([], () => r(require('../././education/main'))),
    'learningdashboardAR'       : r => require.ensure([], () => r(require('../././education/learning_ar'))),
    'learningreport'        : r => require.ensure([], () => r(require('../././education/report'))),
    'registered'     : r => require.ensure([], () => r(require('./components/registered'))),
    // 'showoptions' : r => require.ensure([], () => r(require('./components/showoptions'))),
    'showoptions' : r => require.ensure([], () => r(require('../lms/components/auth/login_en'))),
    'showoptions_arabic' : r => require.ensure([], () => r(require('./components/showoptions_arabic'))),
    'selectLang'        : r => require.ensure([], () => r(require('../././education/selectLang'))),
}

const ForgetPassword = r => require.ensure([], () => r(require('./components/forgotPassword')), 'auth-forget-password')
const PrivacyPolicy = r => require.ensure([], () => r(require('./components/privacyPolicy')), 'auth-privacy-policy')
const termsAndConditions = r => require.ensure([], () => r(require('./components/termsAndConditions')), 'auth-terms-policy')

export default [
    {
        name: 'auth.login',
        path: '/lms/course',
        component: Auth.login,
        meta: { requiresAuth: false },
    },
    {
        name: 'auth.register',
        path: '/register',
        component: Auth.register,
        meta: { requiresAuth: false },
    },
    {
        name: 'auth.registered',
        path: '/registered',
        component: Auth.registered,
        meta: { requiresAuth: false },
    },
    {
        name: 'auth.learning',
        path: '/learning/login/:id',
        component: Auth.learning,
        meta: { requiresAuth: false },
    },
    {
        name: 'auth.learningdashboard',
        path: '/learning/dashboard/:id',
        component: Auth.learningdashboard,
        meta: { requiresAuth: false },
    },
    {
        name: 'auth.learningdashboard',
        path: '/learning_ar/dashboard/:id',
        component: Auth.learningdashboardAR,
        meta: { requiresAuth: false },
    },
    {
        name: 'auth.learningreport',
        path: '/learning/reports/:id',
        component: Auth.learningreport,
        meta: { requiresAuth: false },
    },

    {
        name: 'auth.verification',
        path: '/verification',
        component: Auth.verification,
        meta: { requiresAuth: false },
    },
    {
        name: 'auth.reset',
        path: '/reset',
        component: ForgetPassword,
        meta: { requiresAuth: false },
    },
    {
        name: 'auth.privacypolicy',
        path: '/privacypolicy',
        component: PrivacyPolicy,
        meta: { requiresAuth: false },
    },
    {
        name: 'auth.termsAndConditions',
        path: '/TermsAndConditions',
        component: termsAndConditions,
        meta: { requiresAuth: false },
    },
    {
        name: 'auth.licenceexpire',
        path: '/licenceexpire',
        component: Auth.licenceexpire,
        meta: { requiresAuth: false },
    },
    {
        name: 'auth.registered',
        path: '/registered',
        component: Auth.registered,
        meta: { requiresAuth: false },
    },
    {
      name: 'auth.showoptions',
      path: '/',
      component: Auth.showoptions,
      meta: { requiresAuth: false },
    },
    {
      name: 'auth.showoptions_arabic',
      path: '/options_arabic',
      component: Auth.showoptions_arabic,
      meta: { requiresAuth: false },
    },
    {
        name: 'auth.learningdashboardlang',
        path: '/learning/language',
        component: Auth.selectLang,
        meta: { requiresAuth: false },
    },
]



// WEBPACK FOOTER //
// ./src/app/auth/routes.js